/**
 * Triggers a browser download of the given bytes via a synthetic
 * `<a download>` click - data-app has no filesystem/IPC access (unlike
 * Electron-based ouster-viewer), so this is the only way to hand a
 * client-produced buffer to the user.
 *
 * @param bytes file contents
 * @param filename suggested download filename
 */
export function downloadBlob(bytes: Uint8Array, filename: string): void {
  const blob = new Blob([bytes as BlobPart]);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
